<div class="card">
  <div class="card-body">
    <ng-container *ngTemplateOutlet="InvoiceTemplateExpenses"></ng-container>
  </div>
  <div class="card-footer" fxLayout="row" fxFlex="100" fxLayoutAlign="center" fxLayoutGap="10px" *ngIf="this.invoiceDetailModel.Expenses?.length > 0">
    <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
      <ng-container *ngTemplateOutlet="InvoiceTemplateExpensesDetailSum"></ng-container>
    </div>
  </div>
</div>

<ng-template #InvoiceTemplateExpenses>
  <div fxLayout="column">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
      <div class="card-header-detail">D&Eacute;PENSES / RECETTE :</div>
      <button mat-icon-button color="accent" (click)="addExpense()" *ngIf="!isReadOnlyForm">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="InvoiceTemplateExpensesDetail"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #InvoiceTemplateExpensesDetail>
  <form [formGroup]="invoiceDetailForm" fxLayout="column" fxFlex="100" fxLayoutAlign="start">
    <ng-container formArrayName="InvoiceExpenses">
      <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
        <ng-container *ngFor="let expenseForm of InvoiceExpenses.controls; let i = index">
          <div class="expense-form-row" [formGroup]="expenseForm" fxLayout="column" fxFlex="100" fxLayoutAlign="start">

            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
              <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="70" fxFlex.gt-sm="70" *ngIf="expenseForm.controls['FamilyCode'].disabled">
                  <mat-label>CODE FAMILLE </mat-label>
                  <input matInput formControlName="FamilyCode" type="text" readonly>
                </mat-form-field>
                <div class="dropDownStyle" *ngIf="!expenseForm.controls['FamilyCode'].disabled" fxFlex="70">
                  <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
                    <mat-label>CODE FAMILLE</mat-label>
                    <input matInput formControlName="FamilyCode" type="text" hidden>
                    <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('FamilyCode')}"
                      [settings]="dropDownSettingsExpenseFamilyType" [data]="dropDownDataExpenseFamilyType" formControlName="FamilyCode"
                      (onSelect)="onChangeExpenseFamilyType(i, expenseForm.controls.CreatedAt.value, $event)" (onDeSelect)="onChangeExpenseFamilyType(i, expenseForm.controls.CreatedAt.value, null)"
                      ngDefaultControl>
                    </ng-multiselect-dropdown>
                  </mat-form-field>
                </div>
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="30" fxFlex.gt-sm="30">
                  <mat-label>COMPTE COMPTABLE FAMILLE </mat-label>
                  <input matInput formControlName="FamilyAccount" type="text" readonly>
                </mat-form-field>
              </div>
              <div fxFlex="48" fxFlex.gt-sm="48">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>LIBELLE FAMILLE </mat-label>
                  <input matInput formControlName="FamilyLabel" type="text" readonly maxlength="50">
                </mat-form-field>
              </div>
              <div fxFlex="2" fxFlex.gt-sm="2">

              </div>
            </div>

            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" [ngClass]="InvoiceExpenses.length == (i+1) ? 'customWrapper' : 'customDefaultWrapper'">
              <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>LIBELL&Eacute; </mat-label>
                  <input matInput formControlName="ExpenseLabel" type="text" (change)="onChangeExpenseLabelValue($event)" maxlength="50">
                </mat-form-field>
              </div>
              <div fxFlex="48" fxFlex.gt-sm="48" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="21" fxFlex.gt-sm="21" *ngIf="expenseForm.controls['ExpenseVat'].disabled">
                  <mat-label>% TVA </mat-label>
                  <input matInput formControlName="ExpenseVatReadOnly" type="text" required readonly>
                </mat-form-field>
                <div class="dropDownStyle" *ngIf="!expenseForm.controls['ExpenseVat'].disabled" fxFlex="21">
                  <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
                    <mat-label>% TVA </mat-label>
                    <input matInput formControlName="ExpenseVat" type="text" hidden>
                    <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('ExpenseVat')}"
                      [settings]="dropDownSettingsVat" [data]="dropDownDataVat" formControlName="ExpenseSelectedVat" (onSelect)="onChangeExpenseVat(i, expenseForm.controls.CreatedAt.value, $event)"
                      (onDeSelect)="onChangeExpenseVat(i, expenseForm.controls.CreatedAt.value, null)" ngDefaultControl>
                    </ng-multiselect-dropdown>
                  </mat-form-field>
                </div>
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25">
                  <mat-label>MONTANT HT </mat-label>
                  <input matInput formControlName="ExpenseAmountTaxExcluded" type="text" decimalFormat pattern="^-?[0-9\s]+(?:[,.][0-9]{0,2})?$" step="0.01" (change)="calculatedVat(i, expenseForm)">
                </mat-form-field>
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25">
                  <mat-label>MONTANT TVA </mat-label>
                  <input matInput formControlName="ExpenseAmountVat" type="text" readonly decimalFormat pattern="[-+,0-9\s+]+([,][0-9]{0,2})?" step="0.01">
                </mat-form-field>
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25">
                  <mat-label>MONTANT TTC </mat-label>
                  <input matInput formControlName="ExpenseAmountTaxIncluded" type="text" readonly decimalFormat pattern="[-+,0-9\s+]+([,][0-9]{0,2})?" step="0.01">
                </mat-form-field>
              </div>
              <div fxFlex="2" fxFlex.gt-sm="2">
                <button mat-icon-button color="accent" (click)="deleteExpense(i, expenseForm.controls.CreatedAt.value)" *ngIf="!isReadOnlyFormOrWaiting && i != 0">
                  <mat-icon>remove_circle</mat-icon>
                </button>
              </div>
            </div>

          </div>
        </ng-container>
      </div>
    </ng-container>
  </form>
</ng-template>

<ng-template #InvoiceTemplateExpensesDetailSum>
  <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
    <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
    </div>
    <div fxFlex="48" fxFlex.gt-sm="48" fxLayoutGap="10px">
      <div fxFlex="21" fxFlex.gt-sm="21">
      </div>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25" class="customWrapper">
        <mat-label>SOMME HT </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.expensesSumTaxExcluded}}" type="text" decimalFormat pattern="[-+,0-9\s+]+([,][0-9]{0,2})?" step="0.01" disabled
          [style]="commonLibrary.getSumClass()">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25" class="customWrapper">
        <mat-label>SOMME TVA </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.expensesSumVAT}}" type="text" decimalFormat pattern="[-+,0-9\s+]+([,][0-9]{0,2})?" step="0.01" disabled [style]="commonLibrary.getSumClass()">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25" class="customWrapper">
        <mat-label>SOMME TTC </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.expensesSumTaxIncluded}}" type="text" decimalFormat pattern="[-+,0-9\s+]+([,][0-9]{0,2})?" step="0.01" disabled
          [style]="commonLibrary.getSumClass()">
      </mat-form-field>
    </div>
    <div fxFlex="2" fxFlex.gt-sm="2" fxLayoutGap="10px">
    </div>
  </div>
</ng-template>